import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const GoBackArrowIcon = ({ color, ...rest }) => (
    
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" {...rest} >
    <path fill={color} fill-rule="evenodd" d="M29.063 13.954H3.2l8.602-8.604c.367-.365.367-.959 0-1.325-.366-.366-.959-.366-1.326 0L.275 14.227c-.367.367-.367.96 0 1.326l10.202 10.204c.184.182.423.274.663.274.24 0 .48-.092.663-.274.367-.367.367-.96 0-1.326l-8.602-8.603h25.861c.518 0 .938-.42.938-.938s-.42-.937-.938-.937"/>
</svg>




)
/* --------------------------------------------- */
GoBackArrowIcon.propTypes = {
    /** Color of icon. */
    color: PropTypes.string,
    /** Icon css styles. */
    style: PropTypes.object
}
/* --------------------------------------------- */
GoBackArrowIcon.defaultProps = {
    color: 'transparent',
    
}
/* --------------------------------------------- */
export default GoBackArrowIcon
/* --------------------------------------------- */
